import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import WechatPayIcon from '../../../assets/svg/wechat-pay-logo.svg';
import useStyles from './styles';
import QRCode from 'qrcode';

const WeChatPayResult = ({ link }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [qrCode, setQrCode] = useState('');

    useEffect(() => {
        getQrCode();
    }, [link])

    const getQrCode = async () => {
        const qrCode = await QRCode.toDataURL(link);
        setQrCode(qrCode);
    }

    return (
        <div className={classes.paymentModalInner}>
            <div>
                <img src={WechatPayIcon} alt="wechat-pay-logo" className={classes.paymentModalBrandImg} />
            </div>
            <div className={classes.paymentModalQr}>
                <img src={qrCode} alt='Payment method'/>
            </div>
            <div className="payment-modal-info">
                <label>{t("scan_qr_code")}</label>
            </div>
        </div>
    )
}

export default WeChatPayResult;